<mat-toolbar class="editing-toolbar">
  <span>Editing: {{ currentDataset?.name }}</span>

  <span class="spacer"></span>

  <button mat-raised-button class="tools-button" (click)="saveForm()" [disabled]="saveButtonDisabled">
    <mat-icon svgIcon="content-save"></mat-icon>&nbsp;
    <span>Save</span>
  </button>
</mat-toolbar>

<form [formGroup]="datasetForm" class="dataset-form">
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput formControlName="name" placeholder="Name">
  </mat-form-field>

  <mat-form-field>
    <mat-label>Description</mat-label>
    <textarea matInput formControlName="description" placeholder="Description"></textarea>
  </mat-form-field>

  <div class="slide-control">
    <mat-slide-toggle formControlName="validated"></mat-slide-toggle>
    <mat-label class="slide-label">Validated</mat-label>
  </div>

  <mood-admin-config-fieldset legendTitle="Grouping">
    <div class="grouping-grid grouping-array">
      <mat-form-field>
        <mat-label>Group order</mat-label>
        <input matInput type="number" formControlName="group_order" placeholder="Group order">
      </mat-form-field>

      <mood-select-category-tree-node *ngFor="let node of categoryTreeList" [node]="node"
        [selectedNode]="currentCategoryId"
        (selectedNodeChange)="updateCategory($event)"></mood-select-category-tree-node>
    </div>
  </mood-admin-config-fieldset>

  <mood-admin-config-fieldset legendTitle="External References">
    <div formArrayName="external_references" class="references-array">
      <div *ngFor="let reference of externalReferencesArray.controls; let i=index" class="reference-row">
        <div>
          <mat-divider *ngIf="i !== 0"></mat-divider>
        </div>

        <mood-dataset-admin-reference-form (removeReferenceEntryTriggered)="removeReferenceEntry(i)"
          [formGroupName]="i"></mood-dataset-admin-reference-form>
      </div>

      <button mat-raised-button type="button" (click)="addExternalReference()">
        <mat-icon svgIcon="plus"></mat-icon>
        <span>Add another reference</span>
      </button>
    </div>
  </mood-admin-config-fieldset>

  <mood-admin-config-fieldset legendTitle="Providers">
    <div formArrayName="providers" class="providers-array">
      <div *ngFor="let provider of providersArray.controls; let i=index" class="provider-row">
        <div>
          <mat-divider *ngIf="i !== 0"></mat-divider>
        </div>

        <mood-admin-provider-selection-form (removeProviderEntryTriggered)="removeProviderEntry(i)"
          [formGroupName]="i"></mood-admin-provider-selection-form>
      </div>

      <button mat-raised-button type="button" (click)="addProvider()">
        <mat-icon svgIcon="plus"></mat-icon>
        <span>Add another provider</span>
      </button>
    </div>
  </mood-admin-config-fieldset>

  <div class="slide-control">
    <mat-slide-toggle [formControl]="customColorScaleControl"></mat-slide-toggle>
    <mat-label class="slide-label">Enable Colorscale</mat-label>
  </div>

  <ng-container *ngIf="hasCustomColorScale">
    <mood-admin-color-scale-form formGroupName="color_scale"></mood-admin-color-scale-form>
  </ng-container>

  <mood-admin-raster-layer-form formGroupName="metadata"></mood-admin-raster-layer-form>

  <ng-container *ngIf="isGroupedDataset">
    <mood-grouped-dataset-configuration formGroupName="metadata"></mood-grouped-dataset-configuration>
  </ng-container>

  <ng-container *ngIf="isTimeseriesDataset">
    <mood-timeseries-dataset-configuration formGroupName="metadata"></mood-timeseries-dataset-configuration>
  </ng-container>
</form>
